import React from "react";
import { Link } from "react-router-dom";
import { Linkedin, Mail, Phone } from "lucide-react";
import styles from "./Footer.module.css";
import { useInView } from "../Hooks/useInView";
import logo from "../assets/logo.png";

const Footer: React.FC = () => {
  const [ref, inView] = useInView<HTMLDivElement>(0.25);
  const year = new Date().getFullYear();

  return (
    <footer
      ref={ref}
      className={`${styles.footer} ${inView ? styles.animate : ""}`}
      aria-labelledby="footer-title"
    >
      <h2 id="footer-title" className={styles.srOnly}>
        Website Footer
      </h2>

      <div className={styles.footerTop}>
        <div className={`${styles.footerCol} ${styles.footerColLogo}`}>
          <img src={logo} alt="AVILA Logo" className={styles.logo} />
          <p className={styles.tagline}>
            Erfahrung seit 2003 im Wohnungsbau, Studentenwohnen &amp; betreutem
            Wohnen
          </p>
        </div>
        <div className={styles.footerCol}>
          <h4 className={styles.h4}>Rechtliches</h4>
          <ul className={styles.list}>
            <li>
              <Link to="/impressum">Impressum</Link>
            </li>
            <li>
              <Link to="/datenschutz">Datenschutz</Link>
            </li>
          </ul>
        </div>

        <div className={styles.footerCol}>
          <h4 className={styles.h4}>Kontakt</h4>
          <ul className={`${styles.list} ${styles.contactList}`}>
            <li>
              <Phone size={16} aria-hidden="true" />
              <a href="tel:+493037436370" rel="nofollow">
                +49 30 3743 6370
              </a>
            </li>
            <li>
              <Mail size={16} aria-hidden="true" />
              <a href="mailto:info@avila-projektmanagement.de" rel="nofollow">
                info@avila-projektmanagement.de
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className={styles.footerBottom}>
        <span>© {year} AVILA Projektmanagement GmbH</span>
      </div>
    </footer>
  );
};

export default Footer;
